export { default as DashboardsIcon } from './DashboardsIcon';
export { default as CollectionManagementIcon } from './CollectionManagementIcon';
export { default as ElementDetailsIcon } from './ElementDetailsIcon';
export { default as IncidentManagementIcon } from './IncidentManagementIcon';
export { default as WorkspaceIcon } from './WorkspaceIcon';
export { default as ErrorIcon } from './ErrorIcon';
export { default as SuccessIcon } from './SuccessIcon';
export { default as InfoIcon } from './InfoIcon';
export { default as WarningIcon } from './WarningIcon';
